import { Outlet } from "react-router-dom";
import AnalyticsInitializer from "@/components/AnalyticsInitializer";

export default function AppShell() {
  return (
    <div className="flex min-h-screen flex-col bg-white text-black">
      <AnalyticsInitializer />
      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
}

